import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { useEntity } from '@terminal/react-query-hooks/entities/useEntities';
import { clsx } from 'clsx';
import { ReactNode } from 'react';

import styles from './SentimentSummaryCard.module.scss';

export interface SummaryCitationLinkProps {
  children: ReactNode;
  href?: string;
  entityTag?: string;
}

export const SummaryCitationLink = ({
  children,
  href,
  entityTag,
}: SummaryCitationLinkProps) => {
  const { data } = useEntity(entityTag);
  const entity = data?.data;
  const entityName = entity?.name_short || entity?.name;

  return (
    <a href={href} className={clsx({ [styles.companyCitation]: entityTag })}>
      {entityTag && entity && entityName ? (
        <>
          <AssetLogoContainer entity={entity} size={16} />
          <span>{entityName}</span>
        </>
      ) : (
        children
      )}
    </a>
  );
};
